import React from "react";
import PropTypes from "prop-types";

const InventoryQuantity = ({ quantity, className = "", style = {} }) => {
  const stockLevel = quantityState(quantity);

  return (
    <div
      className={`${quantityClass(quantity)} ${className}`.trim()}
      style={style}
      data-stock-level={stockLevel}
      aria-label={`${quantity} items, ${stockLevel}`}
      title={`${quantity} items · ${stockLevel}`}
    >
      {quantity}
    </div>
  );
};
InventoryQuantity.propTypes = {
  quantity: PropTypes.number.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};
export default InventoryQuantity;

function quantityClass(quantity) {
  if (quantity < 10) {
    return "quantity-danger";
  } else if (quantity >= 10 && quantity <= 20) {
    return "quantity-warning";
  } else {
    return "quantity-good";
  }
}

function quantityState(quantity) {
  if (quantity < 10) return "low stock";
  if (quantity <= 20) return "monitor stock";
  return "in stock";
}
